import moment from 'moment'
import parser from 'parse-ms'
export const prettyCardNumber = cardNumber => {
	if (typeof cardNumber === 'number' || typeof cardNumber === 'string') {
		const parsedNumber =
			cardNumber.slice(0, 6) + '******' + cardNumber.slice(12)
		const text = [...parsedNumber].reverse().join('')
		const array = []
		for (let x = 0; x < text.length; x += 4) {
			array.push([...text.slice(x, x + 4)].reverse().join(''))
		}
		return array.reverse().join().replace(/,/g, ' ')
	} else {
		return ''
	}
}
export const prettyCardValid = cardValid => {
	const validNumber = String(cardValid || '').replace('/', '')
	return validNumber.slice(0, 2) + '/' + validNumber.slice(2)
}
export const prettyDate = (date = '') => moment(date).format('DD.MM.YYYY')
export const prettyDateTime = (date = '') =>
	moment(date).format('DD.MM.YYYY HH:mm:ss')
export const prettyDateTimeHour = (date = '') =>
	moment(date, 'HH:mm:ss').format('HH:mm')
export const prettyFileSize = (bytes, si = true, dp = 1) => {
	const thresh = si ? 1000 : 1024
	if (Math.abs(bytes) < thresh) {
		return bytes + ' B'
	}
	const units = si
		? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
		: ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
	let u = -1
	const r = 10 ** dp
	do {
		bytes /= thresh
		++u
	} while (
		Math.round(Math.abs(bytes) * r) / r >= thresh &&
		u < units.length - 1
	)
	return bytes.toFixed(dp) + ' ' + units[u]
}
export const prettyMilliSeconds = (
	time = 0,
	views = { h: true, s: true, m: true }
) => {
	const { h, m, s } = views
	const { hours, minutes, seconds } = parser(time || 0)
	const hour = h ? String(hours || '').padStart(2, '0') + ':' : ''
	const minute = m ? String(minutes || '').padStart(2, '0') + ':' : ''
	const second = s ? String(seconds || '').padStart(2, '0') : ''
	const newTime = `${hour}${minute}${second}`
	return newTime
}
export const prettyPassportNumber = (passportNumber = '') => {
	const passport = String(passportNumber || '')
	return `${passport.slice(0, 2)} - ${passport.slice(2)}`
}
export const prettyPhoneNumber = (phone = '') => {
	const checkedPhone = String(phone || '')
	const zero = checkedPhone.slice(0, 3)
	const first = checkedPhone.slice(3, 5)
	const second = checkedPhone.slice(5, 8)
	const third = checkedPhone.slice(8, 10)
	const fourth = checkedPhone.slice(10, 12)
	return `+${zero} (${first}) ${second} ${third} ${fourth}`
}
export const prettyPrice = (currency = '') => {
	if (currency === null || currency === undefined || currency === '') return ''
	let value = String(currency).replace(/\s/g, '')

	let num = Number(value)
	if (isNaN(num)) return value

	let [intPart, decPart = ''] = value.split('.')

	if (!decPart || /^0+$/.test(decPart)) {
		return Number(intPart).toLocaleString('ru-RU')
	}

	if (decPart.length > 2) {
		num = Number(num.toFixed(2))
		;[intPart, decPart] = num.toString().split('.')
	}

	const intFormatted = Number(intPart).toLocaleString('ru-RU')
	return `${intFormatted}.${decPart}`
}
export const numberFormatter = (amount, language) => {
	const extensions = {
		billion: {
			ru: 'трлн',
			uz: 'trln',
			en: 'trln',
		},
		milliard: {
			ru: 'млрд',
			uz: 'mlrd',
			en: 'bln',
		},
		million: {
			ru: 'млн',
			uz: 'mln',
			en: 'mln',
		},
		thousand: {
			ru: 'тыс',
			uz: 'ming',
			en: 'K',
		},
	}
	if (amount >= 1_000_000_000_000) {
		const value = (amount / 1_000_000_000_000).toFixed(1).replace(/\.0$/, '')
		const extension = extensions?.billion?.[language]
		const newValue = `${value} ${extension}`
		return newValue
	} else if (amount >= 1_000_000_000) {
		const value = (amount / 1_000_000_000).toFixed(1).replace(/\.0$/, '')
		const extension = extensions?.milliard?.[language]
		const newValue = `${value} ${extension}`
		return newValue
	} else if (amount >= 1_000_000) {
		const value = (amount / 1_000_000).toFixed(1).replace(/\.0$/, '')
		const extension = extensions?.million?.[language]
		const newValue = `${value} ${extension}`
		return newValue
	} else if (amount >= 1_000) {
		const value = (amount / 1_000).toFixed(1).replace(/\.0$/, '')
		const extension = extensions?.thousand?.[language]
		const newValue = `${value} ${extension}`
		return newValue
	}
	return amount
}
export const prettySum = (amount, language) => {
	const currencyLanguages = {
		ru: 'сум',
		uz: "so'm",
		en: 'UZS',
	}
	const currencyLanguage = currencyLanguages?.[language]
	const sum = numberFormatter(amount, language)
	const newSum = `${sum} ${currencyLanguage}`
	return newSum
}
